<template>
  <Form
    ref="voiceDisputeForm"
    :form-data="formData"
    :default-values="fieldValues"
    @onSubmitForm="onSubmitForm"
    @updateOnSearch="onSearch"
    @onChange="onFormChange"></Form>
</template>

<script>
import { voiceDisputeUpdateForm } from "@/config/disputeUpdateModalConstant.js";
import AxiosFetch from "@/utils/axios";
import { getMsalIdToken } from "@/utils/helpers";
import { debounce } from "@/utils/helpers";
// Importing the User Actions
import { userActions } from "@/actions";

// Constants
import { azureActiveDirectoryGroups } from "@/config/constant";

export default {
  name: "DisputeWithVoiceForm",
  props: {
    caseDetails: {
      type: Object,
      default: () => {},
    },
    voiceDisputeData: {
      type: Object,
      default: () => {},
    },
    disputesConstants: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      formData: voiceDisputeUpdateForm(this.disputesConstants) || [],
      fieldValues: {},
    };
  },
  created() {
    const formFields = this.formData.map((el) => el.formFields);
    if (this.caseDetails && Object.keys(this.caseDetails).length) {
      [...formFields[0]]
        .filter((el) => el.type !== "title")
        .forEach((item) => {
          this.fieldValues[item.name] = this.caseDetails[item.name] || null;
        });
    }
    if (this.voiceDisputeData && Object.keys(this.voiceDisputeData).length) {
      [...formFields[0], ...formFields[1]].forEach((item) => {
        this.fieldValues[item.name] = this.voiceDisputeData[item.name];
      });
      if (this.voiceDisputeData?.ohpDisputeVoiceAgent) {
        this.onSearch(
          { searchValue: this.voiceDisputeData?.ohpDisputeVoiceAgent },
          { name: "ohpDisputeVoiceAgent" },
          true
        );
      }
    }
  },
  methods: {
    onSubmitCalled() {
      this.$refs.voiceDisputeForm.validate();
    },
    onSubmitForm(formState, changedFields) {
      this.$emit("onSubmit", formState, changedFields);
    },
    onFormChange(currentDiff) {
      if (typeof currentDiff.isCustomerAligned !== "undefined") {
        this.$refs.voiceDisputeForm.updateFormState("isP2PAgreed", null);
        this.$refs.voiceDisputeForm.updateFormState("expectedP2pDate", null);
        this.$refs.voiceDisputeForm.updateFormState("p2pAmountUsd", null);
      }
    },
    onSearch(searchTerm, field, calledOnMount) {
      if (searchTerm.searchValue && searchTerm.searchValue.length >= 3) {
        this.search(searchTerm, field, calledOnMount, this);
      }
    },
    search: debounce(async (searchTerm, field, calledOnMount, vm) => {
      try {
        if (field.name === "ohpDisputeVoiceAgent") {
          const opts = userActions.getUserListFromAzureAdByEmployeeId(
            searchTerm.searchValue,
            azureActiveDirectoryGroups.azureAdForAssigneeDisputeAccess,
            `Bearer ${await getMsalIdToken(this)}`
          );
          const { data } = await AxiosFetch(opts);
          let users = data.users.map((item) => ({
            ...item,
            value: item.userName,
          }));
          vm.formData = voiceDisputeUpdateForm(vm.disputesConstants, users);
          if (calledOnMount) {
            this.$refs.voiceDisputeForm.updateFormState(
              "ohpDisputeVoiceAgent",
              users[0]
            );
          }
        }
      } catch (err) {
        console.log(err);
      }
    }, 350),
    onBackClicked() {
      const formState = this.$refs.voiceDisputeForm.getFormState();
      this.$emit("updateVoiceData", formState);
    },
  },
};
</script>
